export default __webpack_public_path__ + "static/media/project1.9b59650a.png";